<template>
  <div>  
  <b-card title="Discount Kiosk PO Approval">
    <b-col
      sm="8"
      md="6"
      lg="12"
      class="px-xl-2 mx-auto d-flex justify-content-center"
    >
      <img :src="daikinLogo" style="width: 20%; height: 20%; margin: 0 0 15px 0"/>
    </b-col>

    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <b-form @submit.prevent="">
            <b-row>
              <b-col cols="12" md="6">
                <h5>PO Number: <strong>{{ form.PONumber || 'N/A' }}</strong></h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="6">
                <h5>Payment Type: <strong>{{ displayPaymentType(form.paymentType) }}</strong></h5>
              </b-col>
            </b-row>
            <br />
            <div class="cart__area">
              <div class="card__area-body">
                <div class="table-responsive">
                  <b-table
                    :items="form.items"
                    :fields="tableFields"
                    bordered
                    responsive
                    class=""
                  >
                    <template #cell(no)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(item)="data">
                      {{ getItemDetails(data.item).model }}
                    </template>
                    <template #cell(unitPrice)="data">
                      ${{ formatter(getItemDetails(data.item).price) }} x {{ getItemDetails(data.item).qty }}
                    </template>
                    <template #cell(unitTotal)="data">
                      ${{ formatter(getItemDetails(data.item).totalBeforeDiscount) }}
                    </template>
                    <template #cell(discount)="data">
                      {{ getItemDetails(data.item).discountPercentage }}%
                    </template>
                    <template #cell(discountAmount)="data">
                      ${{ formatter(getItemDetails(data.item).discountAmount) }}
                    </template>
                    <template #cell(totalPrice)="data">
                      ${{ subtotalPrice(data.item) }}
                    </template>
                  </b-table>
                </div>
                <b-card class="pt-1">
                  <b-row>
                    <b-col class="text-right font-weight-bold">Subtotal After Discount:</b-col>
                    <b-col cols="12" md="2" class="text-right">${{ formatter(calculateTotal.subTotal) }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-right font-weight-bold">GST {{ currentGST.value }}%:</b-col>
                    <b-col cols="12" md="2" class="text-right">${{ formatter(calculateTotal.totalGST) }}</b-col>
                  </b-row>
                  <b-row class="mb-0">
                    <b-col class="text-right font-weight-bold">Total Price:</b-col>
                    <b-col cols="12" md="2" class="text-right font-weight-bold">${{ formatter(calculateTotal.grandTotal) }}</b-col>
                  </b-row>
                </b-card>

              </div>

            </div>

            <!-- Informasi Customer -->
            <b-form-group label="Name">
              <b-form-input
                v-model="form.customer.firstName"
                type="text"
                maxlength="40"
                placeholder="Enter Name"
                disabled
              />
            </b-form-group>

            <b-form-group label="Phone">
              <b-form-input
                v-model="form.customer.phone"
                type="text"
                placeholder="Enter Phone"
                disabled
                class="mt-1"
              />
            </b-form-group>

            <b-form-group label="Email">
              <b-form-input
                v-model="form.customer.email"
                type="email"
                placeholder="Enter Email"
                disabled
                class="mt-1"
              />
            </b-form-group>

            <b-form-group label="Remarks">
              <b-form-textarea
                v-model="form.remarks"
                placeholder="Remarks"
                rows="4"
                max-rows="10"
                disabled
                class="mt-1"
              />
            </b-form-group>

            <!-- Action Buttons -->
            <div class="d-flex flex-wrap">
              <b-button v-if="form.orderStatus === 'Awaiting Discount Approval'" @click="modalconfirm = true" type="submit" variant="success" class="mr-1 mb-2">
                Confirm
              </b-button>
              <b-button v-if="form.orderStatus === 'Awaiting Discount Approval'" @click="modalReject = true" type="submit" variant="danger" class="mr-1 mb-2">
                Reject
              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-col>
  </b-card>

  <b-modal 
    v-model="modalconfirm" 
    title="Confirmation"
    @ok="confirm"
    >
    <h5 class="text-center">Are you sure you want to approve this PO ?</h5>
  </b-modal>

  <b-modal 
    v-model="modalReject" 
    title="Rejection"
    @ok="reject"
    >
    <h5 class="text-center">Are you sure you want to reject this PO ?</h5>
  </b-modal>
</div>

</template>


<script>
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "@/axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    "date-picker": DatePicker,
    "v-select": vSelect,
  },
  data() {
    return {
      modalconfirm: false,
      modalReject: false,
      daikinLogo: require('@/assets/images/drcc/daikin-logo.png'),
      form: {
        deliveryType: "SOSC",
        customer: {
          type: "Individual",
          companyName: "",
          firstName: "",
          lastName: "",
          address: "",
          address2: "",
          address3: "",
          buildingName: "",
          phone: "",
          email: "",
          postal: "",
          city: "Singapore",
          street: "",
          block: "",
          floor: "",
          number: ""
        },
        items: [{ itemModel: "", description: "" }],
        deliveryDate: "",
        orderType: "SELF_COLLECT_AMK",
        subTotal: 0,
        tax: 0,
        totalPrice: 0,
        timeslot: null,
        addressType: "",
        priority: "",
        distChan:"",
        deliveryCity: "",
        deliveryPostal: "",
        deliveryPhone: "",
        deliveryEmail: "",
        deliveryAddress: "",
        deliveryAddress2: "",
        deliveryAddress3: "",
        deliveryInstruction: "",
        dealer: "",
        customerPo : "",
        remarks:"",
        poNumber: "",
      },
      tableFields: [
      { key: "no", label: "No" },
      { key: 'item', label: 'Item' },
      { key: 'unitPrice', label: 'Unit Price' },
      { key: 'unitTotal', label: 'Unit Total' },
      { key: 'discount', label: 'Discount' },
      { key: 'discountAmount', label: 'Discount Amount' },
      { key: 'totalPrice', label: 'Total Price' }
    ],
      modalConfirmation :false,
      modalTitle :'',
      messageModal :'',
      replacementMessage: "",
      editQtyMessage:"",
      selectedIndustryType:"",
      industryTypeOption:[],
      industryTypeValid:false,
      mandatoryStatus: true,

      doBlockandUnitFieldsState: false,
      changeItem : false,

      //end of form to save data
      stockError: {},
      item: null,
      itemQty: 0,
      // warehouses: [],
      promptDraft: false,
      orderTypes: [
        { value: "DELIVERY", text: "Delivery" },
      ],
      addBy: "item",
      optionAddress: ["Default Address", "New Delivery Address"],
      categoriesOptions: [],
      category: null,
      categoryItems: [],
      categoryItem: null,
      timestate: null,
      holidays: [],
      deliveryDate: "",
      showBundleModal: false,
      selectedBundle: null,
      bundleQuantity:1,
      publishedItems: [],
      timeslotOptions: [],
      timeslotTemplate:[
        "10 AM to 12 noon",
        "2 PM to 5 PM",
        "6 PM onwards",
      ],
      ajaxItem: null,
      arrayStreet: [],
      arrayBuildingName: [],
      dealerChoice: "", //This is if dealer doesn't detect at active user
      computedItemsResult: [], // hasil akhir dari item yang dihitung
      //button disable
      disableButton: false,
      disableEdit :false,
      disableConfirm: false,
      dataPO: "",
      replacementOptions: {} 
    };
  },
  watch: {
    form: {
      handler() {
        this.computeItems();
      },
      deep: true
    }
  },
  async mounted() {
    this.computeItems();
    let token = this.$route.params.token;

    await this.$store.dispatch("GST/getCurrentGST")

    //ini data kenapa
    await this.$store.dispatch("purchase/getPOByToken", token)
    .then((data) => {
      this.setDetailPurchase(data)
    })
    .catch((error) => {
      console.log(error)
      this.$router.push({ name: "error-404" });
      return
    });
      
  },
  methods: {
    ...mapActions({
      getItemReplacementForDealer: "item/getDealerItemReplacementToOrder",
      discountApprovalProcess: "discount/discountApprovalProcess",
    }),
    formatter(value) {
      console.info('value',value)
      var number = (value.$numberDecimal)?value.$numberDecimal:value;
      if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    getItemDetails(item) {
      const hasReplacement = item.availableReplacementQty != 0 && item.availableReplacementQty;
      const price = hasReplacement ? parseFloat(item.priceReplacement.$numberDecimal || item.priceReplacement) : parseFloat(item.price.$numberDecimal || item.price);
      const qty = hasReplacement ? (item.updatedReplacementQty ?? item.availableReplacementQty) : (item.updatedQty ?? (item.availableQty !== undefined ? item.availableQty : item.qty));
      const discountPercentage = hasReplacement ? (item.unitDiscountReplacement ?? item.unitDiscount) : item.unitDiscount || 0;
      const discountAmount = price * (discountPercentage / 100)*qty;
      const totalBeforeDiscount = price * qty;
      const totalAfterDiscount = totalBeforeDiscount - (totalBeforeDiscount * (discountPercentage / 100));
      
      return {
        model: hasReplacement ? (item.replacementItem ? item.replacementItem.itemModel : '') : item.model,
        price: price,
        qty: qty,
        totalBeforeDiscount: totalBeforeDiscount,
        discountPercentage: discountPercentage,
        discountAmount: discountAmount,
        hasReplacement: hasReplacement,
        totalPrice: totalAfterDiscount
      };
    },
    subtotalPrice(item){
      return this.formatter(this.getItemDetails(item).totalPrice);
    },
    async setDetailPurchase(response){
        let data = response;
        //end detail delivery
        let tempItem = [];
        var itemIndex;
        var priceTemp;
        for (let item of data.items) {

          priceTemp= parseFloat(item.price.$numberDecimal)

          tempItem.push({
            ...item,
            qty: item.qty,
            price: priceTemp,
            totalPrice: priceTemp * (item.updatedQty ? item.updatedQty : 0),
            itemModel: item.model,
            model: item.model,
            description: item.description,
            channel: item.channel,
            id: item.id,
          });
        }
        this.form = {...data} ;
        this.form.customer = data.customerDetail
        this.form.items = tempItem
        
        await this.computeItems()
    },
    async computeItems() {      
      const results = await Promise.all(this.form.items.map(async (item, index) => {
        // (cartItem.price - (cartItem.price * (cartItem.unitDiscount? (cartItem.unitDiscount/100) : 0))) * (cartItem.updatedQty?cartItem.updatedQty : cartItem.qty )
        const details = this.getItemDetails(item);
        item.totalPrice = details.totalPrice;
        
        const baseItem = {
          ...item,
          availableQty: item.availableQty??item.availableQty,
          unitDiscount : item.unitDiscount?? item.unitDiscount,
          isReplacement: false,
          parentIndex: index,
          totalPrice : item.totalPrice,
          updatedQty: item.updatedQty ?? item.availableQty,
          updatedReplacementQty: item.updatedReplacementQty ?? item.availableReplacementQty
        };

        const description = {
          ...baseItem,
          qtyDescription: `Requested qty : ${item.qty}` || 0,
          priceDescription: "-",
          totalPriceDescription: "-",
          parentIndex: index,
          isReplacement: "Description"
        };

        if (item.replacementItem && (item.availableReplacementQty != 0 && item.availableReplacementQty)) {
          const details = this.getItemDetails(item);
          item.totalPriceReplacement = details.totalPrice;

          const replacement = {
            ...baseItem,
            priceReplacement: item.priceReplacement,
            totalPriceReplacement: item.totalPriceReplacement,
            unitDiscountReplacement : item.unitDiscountReplacement,
            isReplacement: true,
            descriptionReplacement: "Replacement Item",
            parentIndex: index,
          };

          return [description, baseItem, replacement];
        } else {
          return [description, baseItem];
        }
      }));

      // Flatten hasilnya
      this.computedItemsResult = results.flat();
    },
    confirm() {
      const payload = {
        status: "Checking",
        approvalToken: this.$route.params.token
      }
      this.$store.dispatch('discount/discountApprovalProcess', payload)
      .then(() => {
        this.form.orderStatus = "Checking"
        this.$bvToast.toast('Approval PO Discount success', {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.modalconfirm = false
        window.close();
      }).catch((e) => {
        this.$bvToast.toast('Approval Discount failed', {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      });
    },
    reject() {
      const payload = {
        status: "Editing",
        approvalToken: this.$route.params.token
      }
      this.$store.dispatch('discount/discountApprovalProcess', payload)
      .then(() => {
        this.form.orderStatus = "Editing"
        this.$bvToast.toast('Reject PO Discount success', {
          title: "Success",
          variant: "success",
          solid: true,
        });
        this.modalReject = false
        setTimeout(() => {
        window.close();
      }, 2000);
      }).catch((e) => {
        this.$bvToast.toast('Reject Approval Discount failed', {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      });
    },
    displayPaymentType(type) {
      switch(type) {
        case 'CASH':
          return 'Paynow';
        case 'MC':
          return 'Credit Card Master Card';
        case 'VISA':
          return 'Credit Card Visa';
        case 'NETS':
          return 'Nets';
        case 'LTER':
          return 'Pay Later';
        default:
          return 'N/A';
      }
    },
  },
  computed: {
    ...mapGetters({
      currentGST: "GST/getCurrentGST",
    }),
    cartTotalPrice: {
      //kalkulasi subtotal
      get() {
        return this.computedItemsResult.reduce((acc, current) => {
          if (current.totalPrice === undefined) {
            return acc;
          }
          if (current.isReplacement == true) {
            return acc + (current.totalPriceReplacement?current.totalPriceReplacement:0);
          }
          if(current.isReplacement == false){
            return acc + current.totalPrice
          }
          return acc
        }, 0);
      },
      set(val) {
        return;
      },
    },
    cartTotalDiscount: {
      //kalkulasi subtotal
      get() {
        return this.computedItemsResult.reduce((acc, current) => {
          if (current.unitDiscount === undefined) {
            acc = parseInt(acc)
            return acc;
          }
          if (current.isReplacement == true) {
            acc = parseInt(acc)
            current.unitDiscount = current.unitDiscount ? parseInt(current.unitDiscountReplacement) : 0
            return acc + current.unitDiscount;
          }
          if(current.isReplacement == false){
            acc = parseInt(acc)
            current.unitDiscount = parseInt(current.unitDiscount)
            return acc + current.unitDiscount
          }
          return acc
        }, 0);
      },
      set(val) {
        return;
      },
    },
    calculateTotal(){
      const data = this.form.items
      let baseTotalPrice = data.reduce((acc, item) => {
        const details = this.getItemDetails(item);
        return acc + (details.price * details.qty);
      }, 0);

      const subTotal = data.reduce((acc, item) => {
        const details = this.getItemDetails(item);
        return acc + details.totalPrice;
      }, 0);

      const totalDiscount = (((baseTotalPrice - subTotal) / baseTotalPrice) * 100).toFixed(2);
      const totalGST = subTotal * this.currentGST.value / 100;
      const grandTotal = (subTotal + totalGST).toFixed(2);
      
      return {
        subTotal,
        totalDiscount,
        totalGST,
        grandTotal
      }
    },
  },
};
</script>

<style>
</style>
